
define('app/board/models/pickModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var PickModel = Backbone.Model.extend({
		defaults: {
			id : null,
			leagueId : null,
			leagueInstanceId : null,
			fantasyTeamId : null,
			draftablePlayerId : 0,
			value : null,
			round : null,
			posInRound : null,
			keeper : null,
			skipped : null,
			autoDrafted : null
	    },
	    
	    urlRoot: function() {
			return '/draftapp/leagues/' + this.get("leagueId") + '/league-instances/' + this.get("leagueInstanceId") + '/picks/';
		},

		initialize: function() {
			
	    },
	    
	    getPosRoundSortValue: function(){
	    	var sortValue = (this.get('round')*1000) + this.get('posInRound')
	    	
	    	//This will order the first auction keepers before the last auction keepers
	    	if(sortValue < 0){
	    		sortValue = -99999999 - sortValue;
	    	}
	    	
	    	return sortValue;
	    }
	});
	
	return PickModel;  
});